module.exports = __webpack_public_path__ + "static/media/2젠더-산딸기크림봉봉.36b1e9a8.mp3";